import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth/store'
import exercises from './exercises/store'
import teams from './teams/store'
import survey from './survey/store'
import view from './view/store'

import createLogger from 'vuex/logger'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
Vue.config.debug = debug

export default new Vuex.Store({
  modules: {
    auth,
    exercises,
    teams,
    survey,
    view
  },
  strict: debug,
  middlewares: debug ? [createLogger()] : []
})




// WEBPACK FOOTER //
// ./src/vuex/store.js